import { Schema as S } from "effect";

export const FindScheduleTypeRequestSchema = S.Struct({
  _id: S.String,
});

export type FindScheduleTypeRequest = S.Schema.Type<
  typeof FindScheduleTypeRequestSchema
>;
